export default __webpack_public_path__ + "static/media/loaderImage.7d72dfca.svg";